/**
 * GTD AI Tools Bounded Context
 * 
 * Following Eric Evans DDD principles:
 * - Co-located AI tools with domain logic
 * - Domain experts maintain AI capabilities
 * - Direct access to domain services
 */

// ===========================================
// APPLICATION LAYER
// ===========================================
export { GTDAIToolsApplicationService } from './application/services/GTDAIToolsApplicationService';

// ===========================================
// INFRASTRUCTURE LAYER
// ===========================================
export { createInboxTools } from './infrastructure/tools/inbox-ai-tools';

// ===========================================
// FACTORY FUNCTION (PUBLISHED LANGUAGE)
// ===========================================
import { InboxItemApplicationService } from '../inbox-management/application/services/InboxItemApplicationService';
import { GTDAIToolsApplicationService } from './application/services/GTDAIToolsApplicationService';

/**
 * Create GTD AI Tools Service with existing inbox service
 */
export function createGTDAIToolsService(
  inboxService: InboxItemApplicationService,
): GTDAIToolsApplicationService {
  return new GTDAIToolsApplicationService(inboxService);
}